import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOnePackage, updatePackage } from 'slice/khajurahoPackageSlice';
import {
    getItineraries,
    addItinerary,
    updateItinerary,
    removeItinerary,
} from 'slice/itinerarySlice';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getUploadUrl } from 'utils/uploadUrl';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, oneData } = useSelector((state) => state.khajurahoPackage);
    const { data: itineraries, loading: itiLoading } = useSelector((state) => state.itinerary);

    const [formData, setFormData] = useState({
        tag: '',
        name: '',
        durationText: '',
        bestTimeText: '',
        activityText: '',
        location: '',
        description: '',
        multipleImages: []
    });
    const [imageFiles, setImageFiles] = useState([]);

    // Itinerary form state
    const [itiForm, setItiForm] = useState({ day: '', title: '', description: '' });
    const [editingIti, setEditingIti] = useState(null); // holds id of item being edited

    const formatImages = (images) => {
        if (!images) return [];
        if (Array.isArray(images)) return images;
        try { return JSON.parse(images); }
        catch (e) { return images.split(',').filter(Boolean); }
    };

    useEffect(() => {
        dispatch(getOnePackage(id));
        dispatch(getItineraries(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData) {
            setFormData({
                tag: oneData.tag || '',
                name: oneData.name || '',
                durationText: oneData.durationText || '',
                bestTimeText: oneData.bestTimeText || '',
                activityText: oneData.activityText || '',
                location: oneData.location || '',
                description: oneData.description || '',
                multipleImages: formatImages(oneData.multipleImages)
            });
            setImageFiles([]);
        }
    }, [oneData]);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file' && name === 'images') {
            setImageFiles(Array.from(files || []));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
        Object.entries(formData).forEach(([key, val]) => {
            if (key !== 'multipleImages') formDataToSend.append(key, val);
        });
        imageFiles.forEach((file) => formDataToSend.append('images', file));
        dispatch(updatePackage({ id, data: formDataToSend }));
        toast.success('Package updated!');
        setTimeout(() => navigate('/khajuraho/packages'), 1500);
    };

    const getImageUrl = (img) => {
        return getUploadUrl(img);
    };

    // ── Itinerary helpers ──────────────────────────────────────────
    const handleItiChange = (e) => {
        setItiForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleAddItinerary = (e) => {
        e.preventDefault();
        if (!itiForm.day || !itiForm.title) {
            toast.error('Day number and title are required');
            return;
        }
        dispatch(addItinerary({ packageId: parseInt(id), day: parseInt(itiForm.day), title: itiForm.title, description: itiForm.description }));
        setItiForm({ day: '', title: '', description: '' });
    };

    const handleEditIti = (item) => {
        setEditingIti(item.id);
        setItiForm({ day: item.day, title: item.title, description: item.description || '' });
    };

    const handleUpdateItinerary = (e) => {
        e.preventDefault();
        dispatch(updateItinerary({ id: editingIti, packageId: parseInt(id), data: { day: parseInt(itiForm.day), title: itiForm.title, description: itiForm.description } }));
        setEditingIti(null);
        setItiForm({ day: '', title: '', description: '' });
    };

    const handleDeleteItinerary = (itiId) => {
        if (window.confirm('Delete this day from itinerary?')) {
            dispatch(removeItinerary({ id: itiId, packageId: parseInt(id) }));
        }
    };

    const cancelEdit = () => {
        setEditingIti(null);
        setItiForm({ day: '', title: '', description: '' });
    };

    return (
        <div className="container-fluid mt-5 pb-5">

            {/* ── Package Details ─────────────────────────────── */}
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Tour Package</h4>
            </div>

            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="tag" className="adminlables">Tag</label>
                        <input type="text" id="tag" name="tag" value={formData.tag} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="name" className="adminlables">Package Name</label>
                        <input type="text" id="name" name="name" value={formData.name} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="durationText" className="adminlables">Duration</label>
                        <input type="text" id="durationText" name="durationText" value={formData.durationText} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="bestTimeText" className="adminlables">Best Time</label>
                        <input type="text" id="bestTimeText" name="bestTimeText" value={formData.bestTimeText} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-4 mt-2">
                        <label htmlFor="location" className="adminlables">Location</label>
                        <input type="text" id="location" name="location" value={formData.location} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="activityText" className="adminlables">Activities</label>
                        <input type="text" id="activityText" name="activityText" value={formData.activityText} className="form-control" onChange={handleChange} />
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="description" className="adminlables">Description</label>
                        <textarea rows={3} id="description" name="description" value={formData.description} className="form-control" onChange={handleChange}></textarea>
                    </div>
                    <div className="col-sm-12 mt-4">
                        <label htmlFor="images" className="adminlables">Add New Images (Optional)</label>
                        <input type="file" id="images" multiple name="images" className="form-control btn-block filebg" onChange={handleChange} />
                    </div>
                    {/* Existing Images */}
                    <div className="col-sm-12 mt-3 d-flex flex-wrap">
                        {formData.multipleImages?.map((img, index) => (
                            <div key={index} className="m-1">
                                <img src={getImageUrl(img)} alt="" width={90} height={65} style={{ objectFit: 'cover' }} className="rounded" />
                            </div>
                        ))}
                        {imageFiles?.map((file, index) => (
                            <div key={index} className="m-1">
                                <img src={URL.createObjectURL(file)} alt="" width={90} height={65} style={{ objectFit: 'cover' }} className="rounded border border-primary" />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="mt-4 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Updating...' : 'Update Package'}
                    </button>
                </div>
            </form>

            {/* ── Itinerary Manager ───────────────────────────── */}
            <div className="mx-4 mt-5">
                <div className="mainheadig mb-3">
                    <h4 className="text-white font-weight-bold">Day-wise Itinerary</h4>
                </div>

                {/* Add / Edit Form */}
                <div className="bg-white p-4 rounded shadow mb-4">
                    <h6 className="font-weight-bold mb-3" style={{ color: '#e67e22' }}>
                        {editingIti ? '✏️ Edit Day' : '➕ Add Day'}
                    </h6>
                    <form onSubmit={editingIti ? handleUpdateItinerary : handleAddItinerary}>
                        <div className="row">
                            <div className="col-sm-2">
                                <label htmlFor="iti-day" className="adminlables">Day No.</label>
                                <input
                                    type="number"
                                    id="iti-day"
                                    name="day"
                                    min="1"
                                    value={itiForm.day}
                                    className="form-control"
                                    onChange={handleItiChange}
                                    required
                                />
                            </div>
                            <div className="col-sm-4">
                                <label htmlFor="iti-title" className="adminlables">Day Title</label>
                                <input
                                    type="text"
                                    id="iti-title"
                                    name="title"
                                    value={itiForm.title}
                                    className="form-control"
                                    onChange={handleItiChange}
                                    placeholder="e.g. Arrival & Temple Visit"
                                    required
                                />
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="iti-desc" className="adminlables">Description</label>
                                <input
                                    type="text"
                                    id="iti-desc"
                                    name="description"
                                    value={itiForm.description}
                                    className="form-control"
                                    onChange={handleItiChange}
                                    placeholder="Brief details about this day..."
                                />
                            </div>
                        </div>
                        <div className="mt-3 d-flex gap-2">
                            <button type="submit" className="btn addbtn" disabled={itiLoading}>
                                {itiLoading ? 'Saving...' : editingIti ? 'Update Day' : 'Add Day'}
                            </button>
                            {editingIti && (
                                <button type="button" className="btn btn-secondary ml-2" onClick={cancelEdit}>
                                    Cancel
                                </button>
                            )}
                        </div>
                    </form>
                </div>

                {/* Itinerary List */}
                <div className="bg-white p-3 rounded shadow">
                    {itiLoading ? (
                        <div className="text-center py-3">Loading itinerary...</div>
                    ) : itineraries && itineraries.length > 0 ? (
                        <table className="table table-hover mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th width="80">Day</th>
                                    <th>Title</th>
                                    <th>Description</th>
                                    <th width="130">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...itineraries]
                                    .sort((a, b) => a.day - b.day)
                                    .map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                <span className="badge badge-warning text-dark font-weight-bold px-2 py-1">
                                                    Day {item.day}
                                                </span>
                                            </td>
                                            <td className="font-weight-bold">{item.title}</td>
                                            <td className="text-muted" style={{ maxWidth: '300px' }}>
                                                {item.description || '—'}
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-info text-white mr-1"
                                                    onClick={() => handleEditIti(item)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => handleDeleteItinerary(item.id)}
                                                >
                                                    Del
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-center text-muted py-3 mb-0">No itinerary days added yet. Use the form above to add them.</p>
                    )}
                </div>
            </div>

        </div>
    );
};

export default Update;
